import { useCallback, useEffect, useRef } from 'react'

export function useTimeout() {
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>()
  const create = useCallback((cb: () => any, ms: number) => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current)
    timeoutRef.current = setTimeout(cb, ms)
  }, [])

  const clear = useCallback(() => {
    if (!timeoutRef.current) return
    clearTimeout(timeoutRef.current)
    timeoutRef.current = undefined
  }, [])

  useEffect(
    () => () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current)
    },
    [],
  )

  return { create, clear }
}
